'use client'

import React from 'react'
import isMobile from 'ismobilejs'
import HorizontalMobileView from './components/MobileView/HorizontalView'
import DesktopView from './components/DesktopView'
import VerticalMobileView from './components/MobileView/VerticalView'

interface BenefitTab {
  id?: string | number
  title?: string
}

interface BenefitsCarousalProps {
  title?: string
  benefitTabs?: BenefitTab[]
  benefitCards?: any[]
  carousalType?: 'horizontal' | 'vertical'
}

const BenefitsCarousal = (data: BenefitsCarousalProps) => {
  const isMobileDevice = isMobile()?.phone
  const carousalType = data?.carousalType || 'vertical'

  if (!isMobileDevice) {
    return <DesktopView title={data?.title} benefitTabs={data?.benefitTabs} benefitCards={data?.benefitCards} />
  }

  if (carousalType === 'vertical') {
    return <VerticalMobileView title={data?.title} benefitCards={data?.benefitCards} />
  }

  return <HorizontalMobileView title={data?.title} benefitCards={data?.benefitCards} />
}

export default BenefitsCarousal
